import * as ko from 'knockout';
import * as $ from 'jquery';

export function init() {
    let translations = require('../root/backend/translations/translations.pl.json');

    let resolve = (path: string, obj: any) => {
        return path.split('.').reduce(function(prev, curr) {
            return prev ? prev[curr] : undefined
        }, obj || self)
    }

    ko.bindingHandlers['translate'] = {
        init: function(element, valueAccessor, allBindings, viewModel, bindingContext) {
            var value = valueAccessor();
            element.innerHTML = resolve(value, translations);
        },
        update: function(element, valueAccessor, allBindings, viewModel, bindingContext) {
        }
    };

    ko.bindingHandlers['widget'] = {
        init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
            var elemObservable = valueAccessor();
            if (ko.isObservable(elemObservable)) {
                elemObservable(element);
            }
        }
    };

    ko.bindingHandlers['currencyHref'] = {
        init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
            let value = ko.unwrap(valueAccessor()) as string;
            if (value == 'EUR') {
                value = 'EURO';
            }

            value = value.toLowerCase();

            $(element).attr('href', `/kurs-${value}.html`)
        }
    };

    ko.bindingHandlers['currencyRateSaleHref'] = {
        init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
            let currencyId = ko.unwrap(valueAccessor()) as string;
            $(element).attr('href', `/panel-klienta/wymiana.html;currencyId=${currencyId}`);
        }
    };

    ko.bindingHandlers['currencyRatePurchaseHref'] = {
        init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
            let currencyId = ko.unwrap(valueAccessor()) as string;
            $(element).attr('href', `/panel-klienta/wymiana.html;currencyToId=${currencyId}`);
        }
    };

    ko.bindingHandlers['numeric'] = {
        init: function (element, valueAccessor) {
            $(element).on("keydown", function (event) {
                // Allow: backspace, delete, tab, escape, and enter
                if (event.keyCode == 46 || event.keyCode == 8 || event.keyCode == 9 || event.keyCode == 27 || event.keyCode == 13 ||
                    // Allow: Ctrl+A
                    (event.keyCode == 65 && event.ctrlKey === true) ||
                    // Allow: . ,
                    (event.keyCode == 188 || event.keyCode == 190 || event.keyCode == 110) ||
                    // Allow: home, end, left, right
                    (event.keyCode >= 35 && event.keyCode <= 39)) {
                    // let it happen, don't do anything
                    return;
                }
                else {
                    // Ensure that it is a number and stop the keypress
                    if (event.shiftKey || (event.keyCode < 48 || event.keyCode > 57) && (event.keyCode < 96 || event.keyCode > 105)) {
                        event.preventDefault();
                    }
                }
            });
        }
    };

    ko.extenders['numeric'] = function(target, precision) {
        var result = ko.computed({
            read: function() {
                if (target()) {
                    return target().toString().replace('.', ',');
                }

                return '';
            },
            write: function(value: string) {
                if (value) {
                    target(parseFloat(value.replace(',','.')));
                } else {
                    target(null);
                }
            }
        });

        return result;
    };

    ko.extenders['maxValue'] = function(target, maxValue) {
        var result = ko.computed({
            read: function() {
                return target();
            },
            write: function(value: number) {
                if (value > maxValue) {
                    target(maxValue);
                } else {
                    target(value);
                }

            }
        });

        return result;
    };

    ko.extenders['minValue'] = function(target, minValue) {
        var result = ko.computed({
            read: function() {
                return target();
            },
            write: function(value: number) {
                if (value < minValue) {
                    target(minValue);
                } else {
                    target(value);
                }

            }
        });

        return result;
    };

    ko.extenders['defaultValue'] = function(target, defaultValue) {
        var result = ko.computed({
            read: function() {
                return target();
            },
            write: function(value: number) {
                if (value == null) {
                    target(defaultValue);
                } else {
                    target(value);
                }

            }
        });

        return result;
    };


    ko.extenders['currency'] = function(target, precision) {
        var result = ko.computed({
            read: function() {
                let result = target();

                if (result != null) {
                    if (precision) {
                        result = result.toFixed(precision);
                    } else {
                        result = result.toString();
                    }

                    result = result.replace('.', ',');

                    return result;
                }

                return '';
            },
        });

        return result;
    };
}
